import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { requestFetchJBPSettings } from 'legacy/lut/features/partner360/jbpSettings/api/requestFetchJBPSettings'

import { getKeyObjectivesFYears } from '../lib'

import { IStrategicInitiativesState, TStrategicInitiativesRtm } from './types'

const initialState: IStrategicInitiativesState = {
  selectedFYear: null,
  selectedRtm: 'Reseller',
  selectedOffering: null,
  offeringsList: [],
  keyObjectives: [],
  yearOptions: [],
  isLoading: false,
}

const strategicInitiativesSlice = createSlice({
  name: 'strategicInitiatives',
  initialState,
  reducers: {
    fYearSelected(state, action: PayloadAction<number | null>) {
      state.selectedFYear = action.payload
    },
    rtmSelected(state, action: PayloadAction<TStrategicInitiativesRtm>) {
      state.selectedRtm = action.payload
    },
    offeringSelected(state, action: PayloadAction<string | null>) {
      state.selectedOffering = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(requestFetchJBPSettings.pending, (state) => {
        state.isLoading = true
      })
      .addCase(requestFetchJBPSettings.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(requestFetchJBPSettings.fulfilled, (state, action) => {
        state.isLoading = false
        state.offeringsList = action.payload.offeringsList
        state.keyObjectives = action.payload.keyObjectives
        state.yearOptions = getKeyObjectivesFYears(action.payload.keyObjectives)

        if (state.selectedFYear === null && state.yearOptions.length) {
          state.selectedFYear = Math.max(...state.yearOptions)
        }
      })
  },
})

export const { fYearSelected, rtmSelected, offeringSelected } = strategicInitiativesSlice.actions

export const strategicInitiativesReducer = strategicInitiativesSlice.reducer
